import React from 'react';
import { CardTitle } from '@spark/ui-components/components/Card';
import { Button } from '@spark/ui-components/components/Button';
import styled from 'styled-components';
const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const AcompanhamentosHeader = ({
  onAdicionar
}) => {
  return <HeaderWrap>
      <div>
        <CardTitle>Lista de Acompanhamentos</CardTitle>
      </div>
      {onAdicionar && <Button variant="primary" onClick={onAdicionar} style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    }}>
          <i className="fas fa-plus" style={{
        fontSize: '16px'
      }}></i>
          Novo Acompanhamento
        </Button>}
    </HeaderWrap>;
};

export default AcompanhamentosHeader;
